import ActionType from 'actions/ActionType'

export default (
  state = false,
  action
) => {
  switch (action.type) {
    case ActionType.SignupForm.ADD_FAILURE:
      return action.payload
    case ActionType.SignupForm.LIST_FAILURE:
      return action.payload
    case ActionType.SignupForm.READ_FAILURE:
      return action.payload
    case ActionType.SignupForm.UPDATE_FAILURE:
      return action.payload
    case ActionType.SignupForm.DELETE_FAILURE:
      return action.payload
    case ActionType.SignupForm.SCHEMA_FAILURE:
      return action.payload
    default:
      return state
  }
}
